<template>
    <div>
        <a-button @click="showModal" class="btn-outline-primary" >
             دریافت خروجی اکسل
        </a-button>

        <a-modal width="1000px" v-model="visible" title="    دریافت خروجی اکسل    " on-ok="handleOk">
            <div class="row">
                <div class="col-md-6 ">
                                    <div class="form-group">
                                        <label style="margin-bottom:10px;">تاریخ پایان </label>
                                        <date-picker v-model="info.end"></date-picker>

                                    </div>
                                </div>
                 <div class="col-md-6 ">
                                    <div class="form-group">
                                        <label style="margin-bottom:10px;">تاریخ شروع </label>
                                        <date-picker v-model="info.start"></date-picker>

                                    </div>
                                </div>
                                
            </div>
            <template slot="footer">
                 <a-button target="_blank" @click.prevent="validate()" :href="`${$store.state.baseUrl}/endurance-export?start=${info.start}&&end=${info.end}`">
                                        <a-icon type="upload" />  خروجی اکسل  
                                    </a-button>
                <a-button key="back" @click="handleCancel">
                    بستن
                </a-button>
            </template>     
         


        </a-modal>
    </div>
</template>
<script>
    export default {
        props: {
            answers: Object,
        },
        data() {
            return {
                loading: false,
                visible: false,
                info:{}
            };
        },
        methods: {
            validate(){
                if(this.info.start == undefined && this.info.end == undefined){
                    this.$toast.error("لطفا شروع و پایان بازه زمانی را وارد کنید.");
                }else{
                location.href=`${this.$store.state.baseUrl}/endurance-export?start=${this.info.start}&&end=${this.info.end}`

                }

            },
            
            
            showModal() {
                this.visible = true;
            },
            handleOk(e) {
                this.loading = true;
                setTimeout(() => {
                    this.visible = false;
                    this.loading = false;
                }, 3000);
            },
            handleCancel(e) {
                this.visible = false;
            },
            
        },
    };
</script>
